export default __webpack_public_path__ + "static/logo-lam-research-23f8b31ab737cd0d21916469864259ac.png";